// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__bUk_S","spin":"styles_spin__cQNrD"};